import React from "react";
import AccordionButton from "./AccordionButton";
import AccordionPanel from "./AccordionPanel";
import AccordionTitle from "./AccordionTitle";

interface AccordionItemProps {
  item: {
    id: string;
    title: React.ReactNode;
    content: React.ReactNode;
  };
  isExpanded: boolean;
  onToggle: (id: string) => void;
  accordionButtonClassName?: string;
  accordionPanelClassName?: string;
}

const AccordionItem = React.forwardRef<HTMLDivElement, AccordionItemProps>(
  (
    {
      item,
      isExpanded,
      onToggle,
      accordionButtonClassName,
      accordionPanelClassName,
    },
    ref
  ) => {
    const handleToggle = () => onToggle(item.id);

    return (
      <div className="w-full" ref={ref}>
        <AccordionButton
          isExpanded={isExpanded}
          onClick={handleToggle}
          ariaControls={`accordion-panel-${item.id}`}
          accordionButtonClassName={accordionButtonClassName}
        >
          <AccordionTitle
            title={item.title}
            titleClassName="text-sm font-semibold text-verba-indigo dark:text-verba-indigo-dk tracking-[0.02em] w-full"
          />
        </AccordionButton>
        <AccordionPanel
          content={item.content}
          isExpanded={isExpanded}
          id={`accordion-panel-${item.id}`}
          ariaLabelledby={`accordion-button-${item.id}`}
          accordionPanelClassName={accordionPanelClassName}
        />
      </div>
    );
  }
);

AccordionItem.displayName = "AccordionItem";

export default AccordionItem;
